import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import Badge from "components/Badge/Badge.js";

import styles from "assets/jss/elite-feats-cms/components/timelineStyle.js";
import { Typography, Box } from "@material-ui/core";

const useStyles = makeStyles(styles);

export default function Timeline(props) {
  const classes = useStyles();
  let { stories, simple } = props;
  if (!stories) {
    stories = [];
  }
  const timelineClass =
    classes.timeline +
    " " +
    cx({
      [classes.timelineSimple]: simple,
    });
  return (
    <ul
      className={timelineClass + " " + "all-client-activity"}
      style={{
        maxWidth: 800,
        width: "100%",
      }}
    >
      {stories.map((prop, key) => {
        const panelClasses =
          classes.timelinePanel +
          " " +
          cx({
            [classes.timelinePanelInverted]: prop.inverted || simple,
            [classes.timelineSimplePanel]: simple,
          });
        const timelineBadgeClasses =
          classes.timelineBadge +
          " " +
          classes[prop.badgeColor] +
          " " +
          cx({
            [classes.timelineSimpleBadge]: simple,
          });
        return (
          <li
            className={classes.item + " " + `client-activity-${key}`}
            key={key}
          >
            {prop.badgeIcon ? (
              <div
                className={timelineBadgeClasses}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <prop.badgeIcon className={classes.badgeIcon} />
              </div>
            ) : null}
            <div className={panelClasses}>
              {prop.title ? (
                <div className={classes.timelineHeading}>
                  <div style={{ display: "flex" }}>
                    <Badge color={prop.titleColor}>
                      <Typography style={{ fontSize: 12, fontWeight: 500 }}>
                        <Box className={`card-title-${key}`}>{prop.title}</Box>
                      </Typography>
                    </Badge>
                  </div>{" "}
                </div>
              ) : null}
              <div className={classes.timelineBody}>{prop.body}</div>
              {prop.footerTitle ? (
                <h6 className={classes.footerTitle}>{prop.footerTitle}</h6>
              ) : null}
              {prop.footer ? <hr className={classes.footerLine} /> : null}
              {prop.footer ? (
                <div className={classes.timelineFooter}>{prop.footer}</div>
              ) : null}
            </div>
          </li>
        );
      })}
    </ul>
  );
}

Timeline.propTypes = {
  stories: PropTypes.arrayOf(PropTypes.object).isRequired,
  simple: PropTypes.bool,
};
